export const SHORT_LIVED_EXPIRATION_DAYS = 14;
export const LONG_LIVED_EXPIRATION_DAYS = 400;
